module.exports = __webpack_public_path__ + "static/media/1-1.b23b8c58.webp";